// ─── Details: Stack ───────────────────────────────────────────
// Vertical stacked list of event details with icon + label + value.

import React from 'react';
import { Calendar, Clock, MapPin, Heart } from 'lucide-react';
import { AnimatedSection } from '../../../lib/animations/AnimatedSection';

const ICONS = { date: Calendar, time: Clock, venue: MapPin, default: Heart };

export default function DetailsStack({ section, data, theme }) {
  const anim = section.animation || {};
  const { date, time, venue, address, note } = data;
  if (!date && !venue) return null;

  const items = [
    date && { icon: 'date', label: 'Date', value: date },
    time && { icon: 'time', label: 'Time', value: time },
    venue && { icon: 'venue', label: 'Venue', value: venue },
    address && { icon: 'venue', label: 'Address', value: address },
    note && { icon: 'default', label: 'Note', value: note },
  ].filter(Boolean);

  return (
    <section className="px-5 py-20" data-testid="event-details-section">
      <div className="max-w-sm mx-auto">
        <AnimatedSection preset={anim.items || 'fade-up'}>
          <p
            className="text-xs tracking-[0.3em] uppercase mb-10 text-center"
            style={{ color: theme.accent, fontFamily: theme.eyebrowFont }}
          >
            Event Details
          </p>
        </AnimatedSection>
        <div className="space-y-6">
          {items.map((item, i) => {
            const Icon = ICONS[item.icon] || ICONS.default;
            return (
              <AnimatedSection key={i} preset={anim.items || 'fade-up'} delay={i * 0.08}>
                <div className="flex items-start gap-4">
                  <div
                    className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
                    style={{ background: `${theme.accent}15` }}
                  >
                    <Icon className="w-4 h-4" style={{ color: theme.accent }} />
                  </div>
                  <div>
                    <p className="text-[10px] tracking-[0.2em] uppercase" style={{ color: theme.textSecondary, fontFamily: theme.eyebrowFont }}>
                      {item.label}
                    </p>
                    <p className="text-sm font-medium mt-0.5" style={{ color: theme.textPrimary, fontFamily: theme.bodyFont }}>
                      {item.value}
                    </p>
                  </div>
                </div>
              </AnimatedSection>
            );
          })}
        </div>
      </div>
    </section>
  );
}
